var scope_0 = require('/codebuild/output/src477529347/src/autopatcher-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/29d082de8225587102729f9619b4dc97.js').default;
var scope_1 = require('/codebuild/output/src477529347/src/autopatcher-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3017eb62732b218f901b06e6c02f3f50.js').default;
var scope_2 = require('/codebuild/output/src477529347/src/autopatcher-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    